// ============================================================================
// Steadfastly - Button Component
// ============================================================================
import React from 'react';

export function Button({ 
  children, 
  variant = "primary", 
  size = "md", 
  disabled, 
  onClick, 
  className = "", 
  darkMode = false 
}) {
  const base = "font-semibold rounded-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center gap-2 active:scale-[0.98]";
  
  const lightVariants = {
    primary: "bg-gradient-to-r from-blue-600 to-indigo-600 text-white hover:from-blue-500 hover:to-indigo-500 shadow-md shadow-blue-500/20 hover:shadow-lg hover:shadow-blue-500/30",
    secondary: "bg-white text-slate-700 border border-slate-200 hover:bg-slate-50 hover:border-slate-300 shadow-sm",
    success: "bg-gradient-to-r from-emerald-500 to-teal-500 text-white hover:from-emerald-400 hover:to-teal-400 shadow-md shadow-emerald-500/20",
    danger: "bg-gradient-to-r from-red-500 to-rose-500 text-white hover:from-red-400 hover:to-rose-400 shadow-md shadow-red-500/20",
    ghost: "text-slate-600 hover:bg-slate-100 hover:text-slate-900",
  };
  
  const darkVariants = {
    primary: "bg-gradient-to-r from-blue-600 to-indigo-600 text-white hover:from-blue-500 hover:to-indigo-500 shadow-lg shadow-blue-500/25 hover:shadow-xl hover:shadow-blue-500/35",
    secondary: "bg-slate-800 text-slate-200 border border-slate-700 hover:bg-slate-700 hover:border-slate-600 shadow-md shadow-black/20",
    success: "bg-gradient-to-r from-emerald-500 to-teal-500 text-white hover:from-emerald-400 hover:to-teal-400 shadow-lg shadow-emerald-500/25",
    danger: "bg-gradient-to-r from-red-500 to-rose-500 text-white hover:from-red-400 hover:to-rose-400 shadow-lg shadow-red-500/25",
    ghost: "text-slate-500 hover:bg-slate-800 hover:text-slate-200",
  };
  
  const variants = darkMode ? darkVariants : lightVariants;
  const sizes = { 
    sm: "px-3 py-1.5 text-xs", 
    md: "px-4 py-2.5 text-sm", 
    lg: "px-5 py-3 text-base" 
  };
  
  return (
    <button 
      disabled={disabled} 
      onClick={onClick} 
      className={`${base} ${variants[variant]} ${sizes[size]} ${className}`}
    >
      {children}
    </button>
  );
}

export default Button;
